import React from "react";
import "./ResourcePage.scss";
import ArtistServices from "../ArtistServices/ArtistServices";

const ResourcePage = ({ image = "", hero = {}, sections = [] }) => {
  const { title, subtitle, description1, description2, reverse } = hero;

  return (
    <>
      <section
        className={`blockchain-services ${
          reverse ? "blockchain-services--reverse" : ""
        }`}
      >
        <div className="blockchain-services__image">
          <img src={image} alt={title} />
        </div>

        <div className="blockchain-services__content">
          <div className="blockchain-services__inner">
            <div className="blockchain-subtitle">
              <h2>{title}</h2>
              {subtitle && <p className="subtitle">{subtitle}</p>}
            </div>

            <div className="descriptions">
              {description1 && <p>{description1}</p>}
              {description2 && <p>{description2}</p>}
            </div>
          </div>
        </div>
      </section>

      <hr className="hr" />

      {sections.map((section) => (
        <ArtistServices
          key={section.key}
          smallTitle={section.smallTitle}
          title={section.title}
          subtitle={section.subtitle}
          paragraphs={section.paragraphs}
        />
      ))}
    </>
  );
};

export default ResourcePage;
